import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f59a3f4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "›", -1))
const _hoisted_3 = { class: "nav-items" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "›", -1))
const _hoisted_5 = { class: "current" }
const _hoisted_6 = { class: "page-scroll-container" }
const _hoisted_7 = { class: "content-layout" }
const _hoisted_8 = { class: "top-row" }
const _hoisted_9 = { class: "left-col" }
const _hoisted_10 = { class: "right-col" }
const _hoisted_11 = { class: "bottom-row" }

import StarXpGate from '@/components/star/StarXpGate.vue'
import { isXpLowVersion } from '@/utils/xpEnv'
import StarTabBar from '@/components/star/StarTabBar.vue'
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStarTheme, useStarRouter } from '@/utils/useStarTheme'
import { fetchStrategyDetail } from '@/api/starresultApi'
import store from '@/store/index'
import StrategyHeader from '.././components/StrategyHeader.vue'
import StrategyDetails from '.././components/StrategyDetails.vue'
import YieldTrend from '.././components/YieldTrend.vue'
import PositionTransactions from '.././components/PositionTransactions.vue'
import BacktestStatusOverlay from '.././components/BacktestStatusOverlay.vue'
import ActionFooter from '.././components/ActionFooter.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'result',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { colors, isDark } = useStarTheme()
const activeTopTab = ref('home')

// Read isFactor from query parameter
// isFactor=1: 组合量化（策略口令）, isFactor=2: 组合量化
const isFactor = computed(() => route.query.isFactor == '1')
console.log('route.query.isFactor', route.query.isFactor)
const cssVars = computed(() => {
  return {
    '--bg-color': colors.value.bg,
    '--card-bg': colors.value.bgCard,
    '--card-bg-sub': colors.value.bgCardSub,
    '--text-primary': colors.value.textPrimary,
    '--text-secondary': colors.value.textSecondary,
    '--text-muted': colors.value.textMuted,
    '--border-color': colors.value.border,
    '--accent-color': colors.value.accent,
    '--divider-color': colors.value.divider,
    '--rise-color': colors.value.rise,
    '--fall-color': colors.value.fall,
  }
})

const { starPush } = useStarRouter()

const goHome = () => {
  starPush('/star')
}
const goGroup = () => {
  starPush('/star/group', { isPassword: isFactor.value ? 'true' : 'false' })
}

// Strategy Details
const strategyDetails1 = ref<any>({})
const holdings = ref<any[]>([])
const tradeID = ref<string>('')
const backtestStatus = ref<number>(2)
const backtestToast = ref<string>('')
const positionTransactionsRef = ref<any>(null)
const yieldTrendRef = ref<any>(null)  
 const pageType      =  ref<number>()
const loadDetail = async () => {
  const taskID = (route.query.taskID as string) || (route.params.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
  const token = (route.query.token as string) || (route.params.token as string)
  const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'

  try {
    const res: any = await fetchStrategyDetail({
      data: { taskID },
      headers: { token, username }
    })

    if (res && res.data) {
      const status = res.data.status as number
      backtestStatus.value = status
      backtestToast.value = res.data.toast || ''
     pageType.value = res.data?.pageType || ''
      if (status === 2) {
        strategyDetails1.value = res.data
        tradeID.value = res.data?.tradeId || ''
        holdings.value = res.data.comResult?.holdings || []
      }
    }
  } catch (error) {
    console.error('Failed to fetch strategy detail:', error)
  }
}

const refreshDetail = () => {
  loadDetail()
  yieldTrendRef.value?.reload()
}

const handleRefreshAll = async () => {
  await loadDetail()
  positionTransactionsRef.value?.reload()
  yieldTrendRef.value?.reload()
}

const strategyTags = computed(() => {
  const tags: string[] = []
  if (!strategyDetails1.value) return tags

  const { quantType, isSubscribed, pageType } = strategyDetails1.value

  // 量化类型 1: 个股-自定义 2: 个股-智能 3: 组合
  if (quantType === 1 || quantType === 2) {
    tags.push('个股量化')
  } else if (quantType === 3) {
    tags.push('组合量化')
  }

  // 订阅状态
  if (isSubscribed) {
    tags.push('已订阅')
  }

  // 创建状态 (已保存)
  // if ( || route.query.from === 'save' || pageType === 2) {
  //   tags.push('创建')
  // }

  return tags
})

const strategyColor = computed(() => {
  const cumRet = strategyDetails1.value?.summary?.cumRet
  if (cumRet == null) return '#ff5c5c'
  if (cumRet > 0) return '#fe4043'
  if (cumRet < 0) return '#39e365'
  return '#888888'
})

onMounted(() => {
  if (isXpLowVersion(route.query as Record<string, unknown>)) return
  if (route.query.isocbt === '1') {
    // 展示"正在回测中"弹窗，由弹窗 3 秒倒计时结束后触发 refresh 请求
    // isocbtPending.value = false
    backtestStatus.value = 1
  } else {
    loadDetail()
  }
})

onUnmounted(() => { })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StarXpGate, { na: "starGroupResult" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "star-result-page star-page",
        style: _normalizeStyle(_unref(cssVars))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(StarTabBar, {
            modelValue: activeTopTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTopTab).value = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", {
            class: "breadcrumb",
            style: _normalizeStyle({ background: _unref(isDark) ? '#181818' : '#ffffff' })
          }, [
            _createElementVNode("span", {
              class: "nav-item",
              onClick: goHome
            }, "首页"),
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(isFactor) ? '组合量化（策略口令）' : '组合量化'), 1),
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(route).query.isfrom == '2' ? '策略详情' :'回测结果'), 1)
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_unref(route).query.isDetails)
                  ? (_openBlock(), _createBlock(StrategyHeader, {
                      key: 0,
                      strategyDetails: strategyDetails1.value,
                      strategyName: strategyDetails1.value.title || '--',
                      tags: _unref(strategyTags),
                      isDark: _unref(isDark)
                    }, null, 8, ["strategyDetails", "strategyName", "tags", "isDark"]))
                  : _createCommentVNode("", true),
                _createVNode(StrategyDetails, {
                  strategyDetails: strategyDetails1.value,
                  isDark: _unref(isDark),
                  isFactor: _unref(isFactor)
                }, null, 8, ["strategyDetails", "isDark", "isFactor"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(YieldTrend, {
                  ref_key: "yieldTrendRef",
                  ref: yieldTrendRef,
                  isDark: _unref(isDark),
                  isFactor: _unref(isFactor),
                  isSubscribed: strategyDetails1.value.isSubscribed,
                  strategyColor: _unref(strategyColor)
                }, null, 8, ["isDark", "isFactor", "isSubscribed", "strategyColor"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(PositionTransactions, {
                ref_key: "positionTransactionsRef",
                ref: positionTransactionsRef,
                isDark: _unref(isDark),
                holdings: holdings.value,
                tradeID: tradeID.value
              }, null, 8, ["isDark", "holdings", "tradeID"])
            ])
          ])
        ]),
        _createVNode(ActionFooter, {
          isDark: _unref(isDark),
          strategyDetails: strategyDetails1.value,
          onRefresh: handleRefreshAll
        }, null, 8, ["isDark", "strategyDetails"]),
        _createVNode(BacktestStatusOverlay, {
          status: backtestStatus.value,
          "toast-string": backtestToast.value,
          onRefresh: refreshDetail
        }, null, 8, ["status", "toast-string"])
      ], 4)
    ]),
    _: 1
  }))
}
}

})